/* eslint-disable */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { friendBot } from 'AppSrc/core/components/dev-page/friend-bot';
import 'AppSrc/core/components/dev-page/style/components/playground.css';


/* Playground is just a simple react enviroment all set up for you to play around with */
/* Please clean up anything you do  so the next person has a clean enviroment 💖      */


/* If you need to easily fire a function, feel free to fire it with the playground button */
/*
💖💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖

  <PlaygroundButton
    callBack={()=> this.forceUpdate()}
    options={null}
    buttonText="Force Render"
  />

💖💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖 💖
*/



class Playground extends PureComponent {
  constructor(props) {
    super(props);

  }
  render() {
    return (
      <React.Fragment>

      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({

});


const mapDispatchToProps = (dispatch) => ({

});

Playground = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Playground);


// Making this var so it gets hoisted and we don't even have to think about it when
// doing stuff in playground
var PlaygroundButton = React.memo(({
  callBack,
  options,
  buttonText,
}) => (
  <button
    type="button"
    className="playground-button"
    onClick={callBack}
    options={options}
  >
    {buttonText}
  </button>
));

PlaygroundButton.defaultProps = {
  callBack: ()=> console.log(friendBot()),
  buttonText: 'Playground Button',
}



const PlaygroundRoot = () => (
  <div className="dev-room-playground">
    <h3>Playground</h3>
    <div className="playground-inner">
      <Playground/>
    </div>
  </div>
);


export { PlaygroundRoot };
